<template>
  <div class="topEvents">
    <div class="header">
      <div class="container">
        <template v-if="gIsLogin()">
          <router-link class="nav" to="/personal_info">完善信息</router-link>
          <span class="nav" @click="logOut">退出登录</span>
        </template>
        <template v-else>
          <router-link class="nav" :to="'/login?fromUrl='+this.$route.path">登录</router-link>
          <router-link class="nav" :to="'/register?fromUrl='+this.$route.path">注册</router-link>
        </template>  
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    // console.log(this.$route.path)
  },
  methods: {
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      // this.$router.push("/login");
      this.$router.go(0);
    },
  }
}
</script>
<style lang="scss" scoped>
.topEvents {
  min-height: 100%;
  padding-top: 60px;
  padding-bottom: 60px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background-size: cover;
    text-align: right;
    z-index: 999;

    .nav {
      line-height: 50px;
      color: #fff;
      padding: 0 10px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>
